if (!customElements.get('component-tooltip')) {
  class ComponentTooltip extends HTMLElement {
    constructor() {
      super();

      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
    }

    connectedCallback() {
      this.trigger = this.querySelector('[data-trigger]');

      ['mouseenter', 'click'].forEach(eventName => {
        this.trigger?.addEventListener(eventName, this.open);
      });

      this.addEventListener('mouseleave', this.close)
    }

    open() {
      this.classList.toggle('is-open');
    }

    close() {
      this.classList.remove('is-open')
    }
  }

  customElements.define('component-tooltip', ComponentTooltip);
}
